@import '~style-sheet-helpers/core';
@import '../../../../../constants/spacing.module.less';

@cardGap: @space-12;

.migration-modal {
  width: 710px;
}

.migration-modal-body {
  padding: @space-16;
}

.migration-modal-content {
  gap: @space-16;
}

.current-plan {
  background: var(--gray-F1F2F3);
}

.plan-name {
  align-items: center;
  gap: @space-8;
}

.line-item-row {
  align-items: center;
  justify-content: space-between;
}

.line-item-detail {
  flex: 0 0 20%;
  align-items: flex-start;
  gap: @space-8;
}

.line-item-title {
  color: var(--grey-600);
}

.line-item-value-row {
  align-items: baseline;
  gap: @space-8;
  flex-flow: row nowrap;
}

.line-item-value {
  font-weight: @bold;

  &.is-discounted {
    color: var(--grey-600);
    text-decoration: line-through;
    text-decoration-color: var(--grey-500);
    font-weight: @normal;
  }
}

.feature-section {
  gap: @space-8;
}

.feature-list {
  font-size: 14px;
  line-height: @space-24;
  margin-left: @space-12;
  padding-left: 0;
  list-style-type: none;

  li {
    list-style-type: none;
    position: relative;
    padding-left: 5px;
    margin-left: 5px;
    padding-top: @space-8;
    width: 100%;

    &:first-of-type {
      padding-top: @space-0;
    }
  }

  li:before {
    color: var(--green-05b45e);
    content: '✓ ';
    position: absolute;
    left: -15px;
  }
}

.call-to-action-text {
  margin-top: @space-8;
}

.offer-details {
  color: var(--gray-637381);
}
